import * as React from 'react';
import { Form, Segment } from 'semantic-ui-react';

import capitalizar from '../../../IngresoNuevaMatricula/utils/capitalizar';
import colores from '../../colores';

export interface Datos {
    asesoresDisponibles: ReadonlyArray<{ id: string; nombre: string }>;
    responsable: string;
    aNombreDe?: {
        id: string;
        nombre: string;
    };
    promotor: string;
    alumnoEsApoderado: boolean;
}

export const inicial: Datos = {
    asesoresDisponibles: [],
    alumnoEsApoderado: false,
    aNombreDe: undefined,
    responsable: '',
    promotor: '',
};

export interface Props {
    preambulo: Datos;
    onChange(preambulo: Datos): void;
}

const alumnoEsApoderadoStyle = { backgroundColor: colores.alumnoEsApoderado };

class Preambulo extends React.PureComponent<Props> {
    public render() {
        const { preambulo, onChange } = this.props;

        const asesoresOptions = [
            {
                key: '',
                value: '',
                text: '',
            },
        ].concat(
            preambulo.asesoresDisponibles.map(a => ({
                key: a.id,
                value: a.id,
                text: a.nombre,
            })),
        );

        return (
            <div>
                <Form.Group widths='equal'>
                    <Form.Input label='Responsable' value={preambulo.responsable} readOnly />
                    <Form.Select
                        label='Asesor comercial (a nombre de)'
                        options={asesoresOptions}
                        value={preambulo.aNombreDe ? preambulo.aNombreDe.id : ''}
                        onChange={(_e, { value }) => {
                            const asesor = preambulo.asesoresDisponibles.find(a => a.id === value);
                            onChange({
                                ...preambulo,
                                aNombreDe: {
                                    id: value as string,
                                    nombre: asesor ? asesor.nombre : '',
                                },
                            });
                        }}
                    />
                    <Form.Input
                        label='Promotor'
                        placeholder='Franco Linco'
                        value={preambulo.promotor}
                        onChange={(_e, { value }) => {
                            onChange({ ...preambulo, promotor: capitalizar(value) });
                        }}
                    />
                </Form.Group>

                <Segment padded inverted style={alumnoEsApoderadoStyle}>
                    <Form.Checkbox
                        label='El alumno es su propio apoderado'
                        checked={preambulo.alumnoEsApoderado}
                        onChange={(_e, { checked }) => {
                            onChange({ ...preambulo, alumnoEsApoderado: checked || false });
                        }}
                    />
                </Segment>
            </div>
        );
    }
}

export default Preambulo;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/S1Preambulo/index.tsx